import { REACT_APP_API_URL } from "../env";
import axios from 'axios';

export const tourBookingApi = {
  getAllBookings: () => axios.get(`${REACT_APP_API_URL}api/tour/list/tour-bookings`)
};
